import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class SingleSignOnIdTokenRejectedError extends CodedError {
  static get errorName() {
    return errorCodes.singleSignOnIdTokenRejected.code;
  }

  constructor(message: string = errorCodes.singleSignOnIdTokenRejected.message) {
    super(message);
    this.code = errorCodes.singleSignOnIdTokenRejected.code;
    this.message = `${message} ${errorCodes.singleSignOnIdTokenRejected.code}`;
    this.name = errorCodes.singleSignOnIdTokenRejected.name;
  }
}
